export default "__VITE_ASSET__DHM5pfLq__"